import PropTypes from 'prop-types';
import { styled, withStyleDeep } from '@activebrands/core-web/libs/styletron';

const Wrapper = styled('div');

const ActivePrice = styled('span', {
    display: 'inline-block',
    whiteSpace: 'nowrap',
});

const OriginalPrice = withStyleDeep(ActivePrice, {
    textDecoration: 'line-through',
});

/**
 * Used to show product prices. Wrapper and active price get data-on-sale="true" | "false" for Optimizely targeting.
 *
 * @param {object} [$style] - Optional styling on wrapper.
 * @param {string} [activePrice] - The active sale price right now with currency.
 * @param {string} [fontKeys] - Text styling.
 * @param {string} [originalPrice] - Original price with currency, will be crossed out if salePrice and originalPrice differs.
 * @param {string} [activePriceSelector] - Optional data-selector on the active price.
 * @param {string} [originalPriceSelector] - Optional data-selector on the original price.
 * @param {string} [selector] - Optional data-selector on wrapper.
 */

const Price = ({
    $style = {},
    activePrice,
    activePriceSelector,
    fontStyling = {},
    originalPrice,
    originalPriceSelector,
    selector,
}) => {
    const onSale = originalPrice && activePrice && activePrice !== originalPrice;
    const onSaleAttribute = onSale ? 'true' : 'false';

    return (
        <Wrapper
            className="price-wrapper"
            $style={{ ...fontStyling, ...$style }}
            data-on-sale={onSaleAttribute}
            data-selector={selector}
        >
            <ActivePrice
                className="active-price"
                data-on-sale={onSaleAttribute}
                data-selector={activePriceSelector}
                $style={{
                    color: onSale ? 'var(--color-text-price-original-active)' : 'var(--color-price-active-original)',
                }}
            >
                {activePrice}
            </ActivePrice>
            {onSale && (
                <OriginalPrice
                    className="original-price"
                    data-selector={originalPriceSelector}
                    $style={{ marginLeft: '4px', color: 'var(--color-text-price-sale-active)' }}
                >
                    {originalPrice}
                </OriginalPrice>
            )}
        </Wrapper>
    );
};

Price.propTypes = {
    $style: PropTypes.object,
    activePrice: PropTypes.string.isRequired,
    activePriceSelector: PropTypes.string,
    fontStyling: PropTypes.object,
    originalPrice: PropTypes.string,
    originalPriceSelector: PropTypes.string,
    selector: PropTypes.string,
};

export default Price;
